import { render, staticRenderFns } from "./TasksDetail.vue?vue&type=template&id=036eca23&"
import script from "./TasksDetail.vue?vue&type=script&lang=tsx&"
export * from "./TasksDetail.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports